export default function SecuritySection() {
    return (
        <div className="section-content">
            <h1>Segurança</h1>
            <div className="config-card">
                <h3>Autenticação</h3>
                <div className="toggle-group">
                    <label className="toggle">
                        <input type="checkbox" defaultChecked />
                        <span className="slider"></span>
                    </label>
                    <span>Autenticação de dois fatores (2FA)</span>
                </div>
                <div className="toggle-group">
                    <label className="toggle">
                        <input type="checkbox" />
                        <span className="slider"></span>
                    </label>
                    <span>Forçar senha forte</span>
                </div>
            </div>
            <div className="config-card">
                <h3>Sessões</h3>
                <div className="form-group">
                    <label>Tempo de expiração (minutos)</label>
                    <input type="number" defaultValue="30" />
                </div>
                <div className="form-group">
                    <label>Tentativas máximas de login</label>
                    <input type="number" defaultValue="5" />
                </div>
                <button className="btn-save">Salvar Configurações</button>
            </div>
        </div>
    );
}